// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-card {
  background-color: rgb(255, 255, 255);
  margin: 25px 0;
  border: 1px solid #ada8a8;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/ministry/municipalities/display-municipality/display-municipality.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;AACF","sourcesContent":[".example-card {\r\n  background-color: rgb(255, 255, 255);\r\n  margin: 25px 0;\r\n  border: 1px solid #ada8a8;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n\r\n\r\n.table-user-information{\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
